// packages
import { useLayoutEffect } from "react";
import React, { useState } from "react";
import ReactDOM from 'react-dom';

import "./gallery.css";
const importAll = (r) => {
  return r.keys().map(r);
};

function AccordionItem({ title, children, isOpen, onClick }) {
  return (
    <div className="bg-white rounded-xl shadow p-4 mb-4">
      <button
        onClick={onClick}
        className="w-full flex justify-between items-center font-semibold text-lg text-left"
      >
        {title}
        <svg
          className={`w-5 h-5 transition-transform ${
            isOpen ? "transform rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && <div className="mt-4">{children}</div>}
    </div>
  );
}

function SubAccordionItem({ title, parent,imageCount, content, isOpen, onClick }) {
  let Images = [];
  for (let x = 1; x <= imageCount; x++) {
    Images.push('./event-gallery/'+parent+'/'+title+'/'+title+' ('+x+').webp');
  }

  console.log(Images);

  return (
    <div className="bg-gray-100 rounded-lg p-3">
      <button
        onClick={onClick}
        className="w-full flex justify-between items-center font-medium text-left"
      >
        {title}
        <svg
          className={`w-4 h-4 transition-transform ${
            isOpen ? "transform rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        // <div className="mt-2 text-gray-600 text-sm">{content}</div>
        <div className="accordianImages">
            <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {Images.map((image, index) => (
              <li className="p-5 h-64 accordian-image-li">
                <img
                src={image}
                alt={image}
                className="accordianImage"
              />
              <a className="accordian-image-download" href={image} download={image}>Download</a>
              </li>
            ))}
              
            </ul>
        </div>
      )}
    </div>
  );
}

const Gallery = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [openMain, setOpenMain] = useState(null);
  const [openSub, setOpenSub] = useState({});

  const toggleMain = (id) => {
    setOpenMain((prev) => (prev === id ? null : id));
    setOpenSub({}); // Reset sub accordions when switching main
  };

  const toggleSub = (mainId, subId) => {
    setOpenSub((prev) => ({
      ...prev,
      [mainId]: prev[mainId] === subId ? null : subId,
    }));
  };

  return (
    <div className="bg-gray-100 p-6">

      {/* {Object.entries(images).map(([path, module], idx) => (        
        <div key={idx} className="bg-white rounded shadow p-2">
          <img src={module.default} alt={`Image ${idx}`} className="w-full h-auto rounded" />
          <p className="text-sm mt-2 text-gray-600 truncate">{path.split('/').pop()}</p>
        </div>
      ))} */}

      <div className="max-w-1xl mx-auto space-y-4">
        {/* Main Accordion 1 */}
        <AccordionItem
          title="Hermann Gmeiner School Faridabad "
          isOpen={openMain === 1}
          onClick={() => toggleMain(1)}
        >
          <div className="space-y-2">
            <SubAccordionItem
              title="Earth Day 2025"
              parent="Faridabad"
              imageCount="15"
              content="Content for Sub Accordion 1"
              isOpen={openSub[1] === 1}
              onClick={() => toggleSub(1, 1)}
            />
            {/* <SubAccordionItem
              title="Sub Accordion 2"
              content="Content for Sub Accordion 2"
              isOpen={openSub[1] === 2}
              onClick={() => toggleSub(1, 2)}
            /> */}
          </div>
        </AccordionItem>

        {/* Main Accordion 2 
        <AccordionItem
          title="Main Accordion 2"
          isOpen={openMain === 2}
          onClick={() => toggleMain(2)}
        >
          <div className="space-y-2">
            <SubAccordionItem
              title="Sub Accordion 1"
              content="Content for Sub Accordion 1 under Main Accordion 2"
              isOpen={openSub[2] === 1}
              onClick={() => toggleSub(2, 1)}
            />
          </div>
        </AccordionItem>
        */}
      </div>
    </div>
  );
}



// const Gallery = () => {
//   useLayoutEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
  

//   return (
//     <>
        
//     test
     
//     </>
//   );
// };

export default Gallery;